import { Route, Routes } from 'react-router-dom';

import styles from './app.module.scss';
import PlanView from './views/plan/plan.view';
import RedeemGiftCardView from './views/redeem-gift-card/redeem-gift-card.view';
import OAuthProvider from './providers/oauth-provider';
import { PaymentProvider } from './providers/payment-provider';
import RemoteConfigProvider from './providers/remote-config-provider';

function App() {
    //const theme = useThemeStore((state) => state.theme);

    return (
        <main id={styles.app}>
            <RemoteConfigProvider>
                <OAuthProvider>
                    <PaymentProvider>
                        <Routes>
                            <Route path={'/'} element={<PlanView />} />
                            <Route
                                path={'/redeem-gift-card'}
                                element={<RedeemGiftCardView />}
                            />
                        </Routes>
                    </PaymentProvider>
                </OAuthProvider>
            </RemoteConfigProvider>
        </main>
    );
}

export default App;
